import React from "react";

const ReactionSuccess = () => (
    <div className="page-container">
        <p>
            Your reaction has been sent to the author! Thanks for supporting their work and encouraging them to make
            more of it.
        </p>
    </div>
);

export default ReactionSuccess;
